<template>
  <div>
    <h2>Menu</h2>
    <app-choose-category ></app-choose-category>
  </div>
</template>

<script>
import ChooseCategory from "@/components/BookingApp/UserView/Menu/ChooseCategory";
export default {
  name: "ChooseACategory",
  
  components: {
    appChooseCategory: ChooseCategory,
  },
  
};
</script>

<style>
</style>